import { useEffect, useState } from "react";

export const defaultPrintSettings = {
  pageSize: "A4",
  customWidth: 210,
  customHeight: 297,
  orientation: "portrait",
  margin: 16,
  scale: 100,
  singlePage: false,
  printBackgrounds: true,
  allowHtml: true,
  tableOfContents: false,
  header: "",
  footer: "",
  pageNumbers: false
};

const STORAGE_KEY = "md2pdf.print-settings";

const normalizeSettings = value => {
  const settings = value || {};
  const margin = Number(settings.margin);
  const customWidth = Number(settings.customWidth);
  const customHeight = Number(settings.customHeight);
  const scale = Number(settings.scale);
  return {
    pageSize: ["Letter", "custom"].includes(settings.pageSize)
      ? settings.pageSize
      : "A4",
    customWidth: Number.isFinite(customWidth)
      ? Math.min(Math.max(customWidth, 50), 500)
      : 210,
    customHeight: Number.isFinite(customHeight)
      ? Math.min(Math.max(customHeight, 50), 500)
      : 297,
    orientation: settings.orientation === "landscape" ? "landscape" : "portrait",
    margin: Number.isFinite(margin) ? Math.min(Math.max(margin, 0), 40) : 16,
    scale: Number.isFinite(scale) ? Math.min(Math.max(scale, 50), 150) : 100,
    singlePage: Boolean(settings.singlePage),
    printBackgrounds: settings.printBackgrounds !== false,
    allowHtml: settings.allowHtml !== false,
    tableOfContents: Boolean(settings.tableOfContents),
    header: String(settings.header || "").slice(0, 200),
    footer: String(settings.footer || "").slice(0, 200),
    pageNumbers: Boolean(settings.pageNumbers)
  };
};

const readSettings = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored ? normalizeSettings(JSON.parse(stored)) : defaultPrintSettings;
  } catch (error) {
    return defaultPrintSettings;
  }
};

const usePrintSettings = () => {
  const [settings, setSettings] = useState(readSettings);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {
      // Settings remain available for the current session when storage is unavailable.
    }
  }, [settings]);

  const updateSettings = next => {
    setSettings(previous => normalizeSettings({ ...previous, ...next }));
  };

  return [settings, updateSettings];
};

export default usePrintSettings;
